@if (processedValue()) {
  <div class="flex max-w-full min-w-0 items-center gap-1.5 whitespace-nowrap">
    <button
      type="button"
      class="hover:border-accent-border hover:bg-accent-interactive bg-elevated border-default inline-flex w-full cursor-pointer items-center overflow-hidden rounded-full border px-2.5 py-0.5 transition-all"
      (click)="$event.stopPropagation(); onClick($event)">
      <span class="text-text-primary text-2xs truncate font-mono font-medium">{{
        displayLabel()
      }}</span>
    </button>
  </div>
}
